import type { RevenueBootstrapEntity } from "../../domain/entities/RevenueBootstrapEntity";

let bootstrapData: RevenueBootstrapEntity | null = null;
let bootstrapPromise: Promise<RevenueBootstrapEntity> | null = null;
let bootstrapError: string | null = null;

export function setRevenueBootstrapData(data: RevenueBootstrapEntity | null): void {
  bootstrapData = data;
}

export function getRevenueBootstrapData(): RevenueBootstrapEntity | null {
  return bootstrapData;
}

export function setRevenueBootstrapPromise(
  promise: Promise<RevenueBootstrapEntity> | null,
): void {
  bootstrapPromise = promise;
}

export function getRevenueBootstrapPromise(): Promise<RevenueBootstrapEntity> | null {
  return bootstrapPromise;
}

export function setRevenueBootstrapError(error: string | null): void {
  bootstrapError = error;
}

export function getRevenueBootstrapError(): string | null {
  return bootstrapError;
}

export function clearRevenueBootstrapStore(): void {
  bootstrapData = null;
  bootstrapPromise = null;
  bootstrapError = null;
}
